export default {
  admin: "ROLE_ADMIN",
  moderator: "ROLE_MODERATOR"
};



// WEBPACK FOOTER //
// ./src/data/admin-roles.js